export const convertHoursToMinutes = (time: TimeIn24Hours) => {
  return time.hours * 60 + time.minutes;
};

export const convertMinutesToHoursAndMinutes = (minutes: number): TimeIn24Hours => {
  const updateHour = Math.floor(minutes / 60);
  const updateMinute = Math.floor(minutes % 60);

  return {
    hours: updateHour,
    minutes: updateMinute,
  };
};
